import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.OffrerenAanvragen, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker || settings.isMaatschappij,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.OffrerenAanvragen,
    title: 'Offreren / Aanvragen',
    url: '/app/aanvraag/recente-activiteiten/offreren-aanvragen',
    iconclass: 'fas fa-calculator',
    target: '_top',
  }),
});
